<template>
    <div class="vx-row">
		<div class="vx-col w-full mb-base">
			<vx-card title="Activate / Deactivate User">
				<div class="vx-row">
					<div class="vx-col sm:w-2/2 w-full mb-2">
                        <label>Set user active status </label>
                        <ul class="con-s">
                            <li>
                                <vs-switch id="sld-user-active" v-model="user.is_active">
                                    <span id="sld-user-active-on" slot="on">Active</span>
                                    <span id="sld-user-active-off" slot="off">Inactive</span>
                                </vs-switch>
                            </li>
                        </ul>
					</div>
				</div>
                <br />
                <div class="vx-row">
					<div class="vx-col w-full">
						<vs-button id="btn-save" color="success" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="setActivation">Save</vs-button>
					</div>
                </div>
			</vx-card>
		</div>
    </div>
</template>

<script>
    import AxiosCall from "@/global/AxiosCall";
    import { url } from '@/configs/apiUrl'

    export default {
        name: "UserConfigure",
        data(){
            return {
                user:{
                    is_active:false
                },
                dataBefore : null,
                auditUser: {
                    user_id: "",
                    session_id: "",
                    user_name: "",
                    menu: "",
                    activity: "",
                    data_before: {},
                    data_after: {},
                },
            }
        },
        methods:{
            openLoading() {
                this.$vs.loading({
                    type: 'default',
                })
            },
            warning(title, text){
                this.$vs.notify({
                    title:title,
                    text:text,
                    color:'warning',
                    position: 'top-right'
                })
            },
            success(title, text){
                this.$vs.notify({
                    title:title,
                    text:text,
                    color:'success',
                    position: 'top-right'
                })
            },
            danger(title, text){
                this.$vs.notify({
                    title:title,
                    text:text,
                    color:'danger',
                    position: 'top-right'
                })
            },
            setActivation(){
                this.auditUser = {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu: "User Management",
                    activity: "Active/Deactive User",
                    data_before: {is_active: this.dataBefore},
                    data_after: {is_active:this.user.is_active},
                }
                this.openLoading()
                AxiosCall.Put(url.svd.user.activation+this.user.id,{is_active:this.user.is_active}).then(response =>{
                    this.$vs.loading.close()
                    if(response.code == 200){
                        this.success("Success", "User activation data successfully updated")
                        this.$store.dispatch('createAuditTrail', this.auditUser)
                    } else {
                        this.danger("Error : User activation failed", "Couldn't set user activation data ("+response.message+")")
                    }
                })
            },
        },
        mounted(){
            if (this.$route.params.id !== undefined){
                AxiosCall.Get(url.svd.user.detail+this.$route.params.id).then(response =>{
                    if(response.code == 200){
                        this.dataBefore = response.data.is_active
                        this.user = response.data
                    } else {
                        this.danger("Error : Retrieve user data failed", "Couldn't retrieve user data ("+response.message+")")
                    }
                })
            }
        },
        props:{
        }
    }
</script>

<style scoped>

</style>